import React from "react";
import { graphql } from "gatsby";
import ObjectLayout from "./../components/ObjectLayout";
import { ObjectBody } from "./../components/ObjectLayout/elements";
import ObjectHeader from "./../components/ObjectHeader";
import ObjectConnections from "./../components/ObjectConnections";
import PdfBlock from "./../components/PdfBlock";

const PdfPage = ({ data }) => {
  const {
    title,
    description,
    date,
    dateApproximateness,
    endDate,
    endDateApproximateness,
    people,
    pdfFile,
    keywords,
    mediaType,
    numberOfPages,
    _rawNotes,
  } = data.sanityObjectPdf;

  return (
    <ObjectLayout title={`PDF: ${title}`}>
      <ObjectHeader
        title={title}
        subtitle={(mediaType && mediaType.title) || ""}
        date={date}
        dateApproximateness={dateApproximateness}
        endDate={endDate}
        endDateApproximateness={endDateApproximateness}
      />
      <ObjectBody>
        <PdfBlock
          description={description}
          notes={_rawNotes}
          pdfId={pdfFile && pdfFile.asset && pdfFile.asset.assetId}
          numberOfPages={numberOfPages}
          title={title}
          showSecondColumn
        />
      </ObjectBody>
      {people.length || keywords.length ? (
        <ObjectConnections people={people} keywords={keywords} />
      ) : null}
    </ObjectLayout>
  );
};

export default PdfPage;

export const pageQuery = graphql`
  query($id: String!) {
    sanityObjectPdf(_id: { eq: $id }) {
      title
      description
      _rawNotes(resolveReferences: { maxDepth: 10 })
      date
      dateApproximateness
      endDate
      endDateApproximateness
      pdfFile {
        asset {
          url
          assetId
        }
      }
      mediaType {
        title
      }
      people {
        _id
        title
      }
      keywords {
        _id
        title
      }
      numberOfPages
      notes {
        _rawChildren
      }
    }
  }
`;
